import React from 'react';
import '../assets/pagination.css'

function Pagination({ nPages, currentPage, setCurrentPage }) {

    const pageNumbers = [...Array(nPages + 1).keys()].slice(1);

    const nextPage = () => {
            if(currentPage !== nPages) setCurrentPage(currentPage + 1)
    }
    const prevPage = () => {
        if(currentPage !== 1) setCurrentPage(currentPage - 1)
    }

  return (
    <nav aria-label="Page navigation example ">
        <ul className="pagination justify-content-center mt-5">
        <li className="page-item ms-2 prec">
            <a className="page-link " onClick={prevPage}>
            <span aria-hidden="true"><img src={window.location.origin +"/images/prec.png"} alt="" /></span>
            </a>
        </li>
            {pageNumbers.map(pgNumero =>(
                <li key={pgNumero}
                    className={`page-item item-page ms-2 ${currentPage == pgNumero ? 'active' : ''} `}>
                    
                    <a onClick={() => setCurrentPage(pgNumero)}
                        className="page-link" href="#">
                        {pgNumero}
                    </a>
                </li>
            ))}
        
        <li className="page-item ms-2 suiv">
            <a className="page-link" onClick={nextPage}>
                <span aria-hidden="true"><img src={window.location.origin +"/images/suiv.png"} alt="" /></span>
            </a>
        </li>
        </ul>
    </nav>
  )
}

export default Pagination;